import { Link, Outlet } from "@tanstack/react-router";
import { Moon, Sun } from "lucide-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AccountControl, SessionGate } from "../features/auth/session-gate";
import { ProgramList } from "../features/programs/program-list";
import { useUiStore } from "../stores/ui-store";
import { Button } from "./ui/button";

function ThemeToggle() {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useUiStore();
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);
  return (
    <Button variant="ghost" size="icon" onClick={toggleTheme} aria-label={t("theme.toggle")} title={t("theme.toggle")}>
      {theme === "dark" ? <Sun className="h-4 w-4" aria-hidden /> : <Moon className="h-4 w-4" aria-hidden />}
    </Button>
  );
}

/** Header, then the programs list beside the selected page. */
export function AppShell() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col">
      <header className="flex h-14 items-center justify-between border-b border-border px-4">
        <Link to="/" className="font-semibold">
          {t("app.title")}
        </Link>
        <div className="flex items-center gap-2">
          <ThemeToggle />
          <AccountControl />
        </div>
      </header>
      <SessionGate>
        <div className="flex flex-1 flex-col lg:flex-row">
          <aside className="border-b border-border lg:w-72 lg:shrink-0 lg:border-b-0 lg:border-r">
            <ProgramList />
          </aside>
          <main className="min-w-0 flex-1">
            <Outlet />
          </main>
        </div>
      </SessionGate>
    </div>
  );
}
